interface Table {
  queryForm: any;
  list: any;
  total: number;
  loading: boolean;
}

export default function useTable(
  table: Table,
  getList: () => void,
  tableRef: any
) {
  //検索イベント
  const handleSearch = (page: number) => {
    tableRef.value.clearSort();
    table.queryForm.page = page;
    getList();
  };

  const handleSizeChange = (size: number) => {
    table.queryForm.limit = size;
    handleSearch(1);
  };

  //クリアイベント
  const handleClear = () => {
    const form = table.queryForm;
    Object.keys(table.queryForm).map((key) => {
      if (key === "page") {
        form[key] = 0;
      } else if (key === "limit") {
        form[key] = 20;
      } else if (typeof form[key] === "string") {
        form[key] = "";
      } else if (typeof form[key] === "boolean") {
        form[key] = false;
      } else if (typeof form[key] === "number") {
        form[key] = 0;
      } else if (typeof form[key] === "object") {
        form[key] = null;
      }
    });
    handleSearch(1);
  };

  return {
    handleSizeChange,
    handleSearch,
    handleClear,
  };
}
